import { render, staticRenderFns } from "./Anamnesis.vue?vue&type=template&id=0ddd3832"
import script from "./Anamnesis.vue?vue&type=script&lang=js"
export * from "./Anamnesis.vue?vue&type=script&lang=js"
import style0 from "./Anamnesis.vue?vue&type=style&index=0&id=0ddd3832&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports